import { CardHeader } from "../../../components/CardHeader";
import { FormRow } from "../../common/hook-form";
import { useFormContext } from "react-hook-form";
import * as Inputs from "../../common/hook-form/index";

export const ChallengeValiditySection = () => {
  const { register, formState } = useFormContext();

  return (
    <div className="card">
      <CardHeader
        title="Challenge validity"
        subtitle="Configure the challenge validity. Choose when users are able to complete the challenge."
      />
      <div className="card-body">
        <FormRow>
          <Inputs.InputFormField
            errors={formState.errors}
            register={register}
            label="Challenge visible from"
            name="activeFrom"
            type="datetime-local"
            helpText="This is the first day the challenge is visible for the user."
          />
          <Inputs.InputFormField
            errors={formState.errors}
            register={register}
            label="Challenge visible to"
            name="activeExpiresAt"
            type="datetime-local"
            helpText="This is the last day the challenge is visible for the user."
          />
        </FormRow>
      </div>
    </div>
  );
};
